module.exports = __webpack_public_path__ + "img/126.92dc45bc.jpg";